import { useState, useCallback, useRef } from 'react';
import { GetToken } from '@utils/storage';
import { handleRevokedPayload } from '@utils/session';
import * as config from '@config';

function useAccountUpdate() {
    const [updating, setUpdating] = useState(false);
    const abortRef = useRef();

    const updateAccount = useCallback(async (id, req) => {
        abort();
        setUpdating(true);
        abortRef.current = new AbortController();
        try {
            const response = await fetch(`${config.apiURL}/user/${id}`, {
                signal: abortRef.current.signal,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${GetToken()}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(req),
            });
            if (!response.ok) {
                const data = await response.json();
                // A revoked account ends the session rather than reporting a
                // failure the user can do nothing about.
                handleRevokedPayload(data);
                throw new Error(data.error || 'Update account failed');
            }
            const data = await response.json();
            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error update account:', error);
            }
            throw error;
        } finally {
            setUpdating(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortRef.current) {
            abortRef.current.abort();
        }
    }, []);

    return { updating, updateAccount, abort };
}

export default useAccountUpdate;
